import React, { Suspense } from "react";
import { Outlet, useParams } from "react-router-dom";
import {
  SidebarProvider,
  SidebarInset,
  readSidebarStateCookie,
} from "components/common/Sidebar/Sidebar";
import {
  sidebarShellChromeClassName,
  sidebarShellContentPanelClassName,
} from "components/layout/shell/sidebarShell";
import { cn } from "utils/cn";
import RouteFallback from "routes/RouteFallback";
import { AppUpdateBanner } from "components/common/AppUpdateBanner";
import { AppHeader } from "components/layout/shell/AppHeader";
import { WorkspaceSettingsSidebar } from "components/layout/shell/AppSidebar";
import { GlobalNavigationSearchProvider } from "components/layout/shell/GlobalNavigationSearch";
import { useAnalytics } from "hooks/useAnalytics";

export const WorkspaceLayout = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { setWorkspaceGroup } = useAnalytics();

  React.useEffect(() => {
    if (workspaceId) setWorkspaceGroup(workspaceId);
  }, [workspaceId, setWorkspaceGroup]);

  return (
    <SidebarProvider defaultOpen={readSidebarStateCookie() ?? true}>
      <GlobalNavigationSearchProvider>
        <WorkspaceSettingsSidebar />
        <SidebarInset className="flex h-full min-h-0 flex-col overflow-hidden">
          <div className={sidebarShellChromeClassName}>
            <AppUpdateBanner />
            <AppHeader />
            <main className={cn(sidebarShellContentPanelClassName, "overflow-auto")}>
              <Suspense
                fallback={<RouteFallback containerClassName="h-full min-h-[calc(100svh-54px)]" />}
              >
                <Outlet />
              </Suspense>
            </main>
          </div>
        </SidebarInset>
      </GlobalNavigationSearchProvider>
    </SidebarProvider>
  );
};
